require('bootstrap');
import { createApp } from 'vue';
import { defineRule } from 'vee-validate';
import { required, email } from '@vee-validate/rules';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import Loading from 'vue-loading-overlay';
import Vue3Autocounter from 'vue3-autocounter';
import TeamCarousel from './components/TeamCarousel.vue';
import PagesCarousel from './components/PagesCarousel.vue';
import ImagesCarousel from './components/ImagesCarousel.vue';
import ContactUsForm from './components/ContactUsForm.vue';
import SocialIcons from './components/SocialIcons.vue';
import BgVideo from './components/BgVideo.vue';
import PriceRange from './components/PriceRange.vue';
import CircleProgressBar from './components/CircleProgressBar';
import GMapWidget from './components/GMapWidget.vue';
import CookieNotificator from './components/CookieNotificator';
import BrokerContactForm from './components/BrokerContactForm';

// Define the rule globally
defineRule('required', required);
defineRule('email', email);

window.app = createApp({
    components: {
        FontAwesomeIcon,
        TeamCarousel,
        PagesCarousel,
        ImagesCarousel,
        ContactUsForm,
        SocialIcons,
        BgVideo,
        PriceRange,
        CircleProgressBar,
        GMapWidget,
        CookieNotificator,
        BrokerContactForm,
    },
});

window.app.component('vue3-autocounter', {
    extends: Vue3Autocounter,
    props: {
        duration: {
            type: Number,
            default: 4,
        },
        separator: {
            type: String,
            default: ' '
        },
    },
});

window.app.component('loading', {
    extends: Loading,
    props: {
        loader: {
            type: String,
            default: 'spinner',
        },
        width: {
            type: Number,
            default: 128,
        },
        height: {
            type: Number,
            default: 128,
        },
        backgroundColor: {
            type: String,
            default: '#fff',
        },
        color: {
            type: String,
            default: '#115370',
        },
        opacity: {
            type: Number,
            default: 0.7,
        },
        canCancel: {
            type: Boolean,
            default: false,
        },
        isFullPage: {
            type: Boolean,
            default: true,
        },
    },
});

window.app.mount('#app');

require('./handlers.js');
